import {
  GET_SUPPORT_CATEGORIES,
  GET_SUPPORT_CATEGORIES_SUCCESS,
  GET_SUPPORT_CATEGORIES_FAILURE,
  GET_SUPPORT_CATEGORY_ARTICLES,
  GET_SUPPORT_CATEGORY_ARTICLES_SUCCESS,
  GET_SUPPORT_CATEGORY_ARTICLES_FAILURE,
  GET_SUPPORT_SEARCH_ARTICLES,
  GET_SUPPORT_SEARCH_ARTICLES_SUCCESS,
  GET_SUPPORT_SEARCH_ARTICLES_FAILURE,
  GET_SUPPORT_INDEX,
  GET_SUPPORT_INDEX_SUCCESS,
  GET_SUPPORT_INDEX_FAILURE,
} from "@store/support/constants";

import { makeApiCall } from "@lib/api/helpers";
import {
  getSupportCategoriesApi,
  getSupportCategoryArticlesApi,
  getSupportSearchArticlesApi,
  getSupportIndexApi,
} from "@lib/api";

export const getSupportCategories = () => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SUPPORT_CATEGORIES,
      success: GET_SUPPORT_CATEGORIES_SUCCESS,
      fail: GET_SUPPORT_CATEGORIES_FAILURE,
    },
    dispatch,
    getState,
    apiCall: getSupportCategoriesApi,
    formatResponse: (response) => response.data,
  });
};

export const getSupportCategoryArticles =
  (category) => (dispatch, getState) => {
    return makeApiCall({
      actions: {
        action: GET_SUPPORT_CATEGORY_ARTICLES,
        success: GET_SUPPORT_CATEGORY_ARTICLES_SUCCESS,
        fail: GET_SUPPORT_CATEGORY_ARTICLES_FAILURE,
      },
      dispatch,
      getState,
      apiCall: getSupportCategoryArticlesApi,
      apiArgs: [encodeURIComponent(category)],
      formatResponse: (response) => response.data,
    });
  };

export const getSupportSearchArticles =
  (searchParams) => (dispatch, getState) => {
    return makeApiCall({
      actions: {
        action: GET_SUPPORT_SEARCH_ARTICLES,
        success: GET_SUPPORT_SEARCH_ARTICLES_SUCCESS,
        fail: GET_SUPPORT_SEARCH_ARTICLES_FAILURE,
      },
      dispatch,
      getState,
      apiCall: getSupportSearchArticlesApi,
      apiArgs: [searchParams],
      formatResponse: (response) => response.data,
    });
  };

export const getSupportIndex = () => (dispatch, getState) => {
  return makeApiCall({
    actions: {
      action: GET_SUPPORT_INDEX,
      success: GET_SUPPORT_INDEX_SUCCESS,
      fail: GET_SUPPORT_INDEX_FAILURE,
    },
    dispatch,
    getState,
    apiCall: getSupportIndexApi,
    formatResponse: (response) => response.data,
  });
};
